import { getLabelFormatBySeriesNumber } from "src/components/Charts/Simple/echarts/BarChart/labels";
import toBarEchartOption from "src/components/Charts/Simple/echarts/BarChart/toEchartOption";
import toPieEchartOption from "src/components/Charts/Simple/echarts/PieChart/toEchartOption";
import toFunnelEchartOption from "src/components/Charts/Simple/echarts/FunnelChart/toEchartOption";
import toHorizontalBarEchartOption from "src/components/Charts/Simple/echarts/StackedBarChart/toEchartOption";
import toVerticalBarEchartOption from "src/components/Charts/Simple/echarts/VerticalStackedBarChart/toEchartOption";
import toSimpleCrossBarEchartOption from "src/components/Charts/SimpleCross/echarts/SingleStackChart/toEchartOption";
import toEvolutiveBarEchartOption from "src/components/Charts/Evolutive/echarts/BarChart/toEchartOption";
import toEvolutiveLineEchartOption from "src/components/Charts/Evolutive/echarts/LineChart/toEchartOption";
import toRadarEchartOption from "src/components/Charts/Simple/echarts/Radar/toEchartOption";
import toPieGradeEchartOption from "src/components/Charts/Simple/echarts/PieChart/toEchartOptionGradeUnica";
import toTreeMapEchartOption from "src/components/Charts/Correlation/echarts/TreeMapChart/toEchartOption";
import toSimpleBubbleEchartOption from "src/components/Charts/Correlation/echarts/SimpleBubbleChart/toEchartOption";
import toGraphBubbleEchartOption from "src/components/Charts/Correlation/echarts/GraphBubbleChart/toEchartOption";

const { BAR, PIE, FUNNEL, LINE, HORIZONTAL_STACKED, VERTICAL_STACKED, RADAR, PIE_GRADE, TREE_MAP, SIMPLE_BUBBLE, GRAPH_BUBBLE } = require("src/components/Charts/types");
const { SIMPLE_CARD, MULTIPLE_CARD, SIMPLECROSS_CARD, EVOLUTIVE_CARD, EVOLUTIVE_CROSS_CARD, CORRELATION_CARD } = require("src/sections/GroupCards/cardTypes");

// Strategy: Calcula e recupera as opções do gráfico de funil.
function defaultFunnelChartStrategy(data, colors, fontSize, disabledLegends, _, __, highlitIndex) {
  return {
    options: toFunnelEchartOption(data, colors, fontSize, disabledLegends, highlitIndex),
    toEchartOption: toFunnelEchartOption,
  };
}

// Strategy: Calcula e recupera as opções do gráfico de pizza simples.
function defaultPieChartStrategy(data, colors, fontSize, disabledLegends, _, __, highlitIndex) {
  return {
    options: toPieEchartOption(data, colors, fontSize, disabledLegends, highlitIndex),
    toEchartOption: toPieEchartOption,
  };
}

// Strategy: Calcula e recupera as opções do gráfico de barras simples.
function defaultBarChartStrategy(data, colors, fontSize, disabledLegends, chartSize, currentOptions, highlitIndex, ascOrder) {
  let formatter;

  if (currentOptions) {
    // Resolve qual labelFormatter que será utilizado pelo gráfico de barras.
    formatter = getLabelFormatBySeriesNumber(
      currentOptions.series.length - disabledLegends.length,
      chartSize,
      true,
      0,
      false,
    );
  }

  return {
    options: toBarEchartOption(data, colors, formatter, fontSize, disabledLegends, highlitIndex, ascOrder),
    toEchartOption: toBarEchartOption,
  };
}

// Strategy: Calcula e recupera as opções do gráfico de barras horizontal.
function defaultHorizontalBarChartStrategy(data, colors, fontSize, disabledLegends, _, __, highlitIndex) {
  return {
    options: toHorizontalBarEchartOption(data, colors, fontSize, disabledLegends, highlitIndex),
    toEchartOption: toHorizontalBarEchartOption,
  };
}

// Strategy: Calcula e recupera as opções do gráfico de barras vertical.
function defaultVerticalBarChartStrategy(data, colors, fontSize, disabledLegends, _, __, highlitIndex) {
  return {
    options: toVerticalBarEchartOption(data, colors, fontSize, disabledLegends, highlitIndex),
    toEchartOption: toVerticalBarEchartOption,
  };
}

// Strategy: Calcula e recupera as opções do gráfico de barras de cruzamentos simples.
function defaultSimpleCrossBarChartStrategy(data, colors, fontSize, disabledLegends, _, __, highlitIndex) {
  return {
    options: toSimpleCrossBarEchartOption(data, colors, fontSize, disabledLegends, highlitIndex),
    toEchartOption: toSimpleCrossBarEchartOption,
  }
}

// Strategy: Calcula e recupera as opções do gráfico de barras evolutivo.
function defaultEvolutiveBarChartStrategy(data, colors, fontSize, disabledLegends, _, __, highlitIndex) {
  return {
    options: toEvolutiveBarEchartOption(data, colors, fontSize, disabledLegends, highlitIndex),
    toEchartOption: toEvolutiveBarEchartOption,
  }
}

// Strategy: Calcula e recupera as opções do gráfico de linhas evolutivo.
function defaultEvolutiveLineChartStrategy(data, colors, fontSize, disabledLegends, _, __, highlitIndex) {
  return {
    options: toEvolutiveLineEchartOption(data, colors, fontSize, disabledLegends, highlitIndex),
    toEchartOption: toEvolutiveLineEchartOption,
  }
}

// Strategy: Calcula e recupera as opções do gráfico de radar.
function defaultRadarChartStrategy(data, colors, fontSize, disabledLegends, _, __, highlitIndex) {
  return {
    options: toRadarEchartOption(data, colors, fontSize, disabledLegends, highlitIndex),
    toEchartOption: toRadarEchartOption,
  };
}

// Strategy: Calcula e recupera as opções do gráfico de pizza grade.
function defaultPieGradeChartStrategy(data, colors, fontSize, disabledLegends, _, __, highlitIndex) {
  return {
    options: toPieGradeEchartOption(data, colors, fontSize, disabledLegends, highlitIndex),
    toEchartOption: toPieGradeEchartOption,
  };
}

// Strategy: Calcula e recupera as opções do gráfico de treemap (correlação).
function defaultTreeMapChartStrategy(data, colors, fontSize, disabledLegends, _, __, highlitIndex) {
  return {
    options: toTreeMapEchartOption(data, colors, fontSize, disabledLegends, highlitIndex),
    toEchartOption: toTreeMapEchartOption,
  };
}

// Strategy: Calcula e recupera as opções do gráfico de bubble simples (correlação).
function defaultSimpleBubbleChartStrategy(data, colors, fontSize, disabledLegends, _, __, highlitIndex) {
  return {
    options: toSimpleBubbleEchartOption(data, colors, fontSize, disabledLegends, highlitIndex),
    toEchartOption: toSimpleBubbleEchartOption,
  };
}

// Strategy: Calcula e recupera as opções do gráfico de graph bubble (correlação).
function defaultGraphBubbleChartStrategy(data, colors, fontSize, disabledLegends, _, __, highlitIndex) {
  return {
    options: toGraphBubbleEchartOption(data, colors, fontSize, disabledLegends, highlitIndex),
    toEchartOption: toGraphBubbleEchartOption,
  };
}

export const echartOptionStrategies = {
  [`${SIMPLE_CARD}_${BAR}`]: defaultBarChartStrategy,
  [`${SIMPLE_CARD}_${PIE}`]: defaultPieChartStrategy,
  [`${SIMPLE_CARD}_${FUNNEL}`]: defaultFunnelChartStrategy,
  [`${SIMPLE_CARD}_${HORIZONTAL_STACKED}`]: defaultHorizontalBarChartStrategy,
  [`${SIMPLE_CARD}_${VERTICAL_STACKED}`]: defaultVerticalBarChartStrategy,
  [`${SIMPLE_CARD}_${RADAR}`]: defaultRadarChartStrategy,
  [`${SIMPLE_CARD}_${PIE_GRADE}`]: defaultPieGradeChartStrategy,
  [`${MULTIPLE_CARD}_${PIE}`]: defaultPieChartStrategy,
  [`${MULTIPLE_CARD}_${BAR}`]: defaultBarChartStrategy,
  [`${SIMPLECROSS_CARD}_${BAR}`]: defaultSimpleCrossBarChartStrategy,
  [`${EVOLUTIVE_CARD}_${BAR}`]: defaultEvolutiveBarChartStrategy,
  [`${EVOLUTIVE_CARD}_${LINE}`]: defaultEvolutiveLineChartStrategy,
  [`${EVOLUTIVE_CROSS_CARD}_${BAR}`]: defaultEvolutiveBarChartStrategy,
  [`${EVOLUTIVE_CROSS_CARD}_${LINE}`]: defaultEvolutiveLineChartStrategy,
  [`${CORRELATION_CARD}_${TREE_MAP}`]: defaultTreeMapChartStrategy,
  [`${CORRELATION_CARD}_${SIMPLE_BUBBLE}`]: defaultSimpleBubbleChartStrategy,
  [`${CORRELATION_CARD}_${GRAPH_BUBBLE}`]: defaultGraphBubbleChartStrategy,
};